import React from "react"
import { useTranslation } from "react-i18next"
import Stack from "@mui/material/Stack"
import { Message } from "components/atoms/EmptyState"
import LazyImage from "components/atoms/LazyImage"

export default function ExploreEmptyState() {
  const { t } = useTranslation()

  return (
    <Stack position="relative" alignItems="center" height="100%" flexGrow={1} justifyContent="center">
      <LazyImage
        src={"/static/images/placeholder/no-image-1.svg"}
        alt={"not-found"}
        style={{ width: "30%", height: "auto" }}
      />
      <Message>{t("general.nothingFound")}</Message>
    </Stack>
  )
}
